document.addEventListener('DOMContentLoaded', function() {
  // Function to handle button click event
  function handleButtonClick(event) { 
    
    // Select all checkboxes with the name "bundle_add_to_cart[]"
    var checkboxes = document.querySelectorAll('input[name="bundle_add_to_cart[]"]');
    var checkedValues = [];

    // Iterate over each checkbox
    checkboxes.forEach(function(checkbox) {
      // Check if the checkbox is checked  
      if (checkbox.checked) {
      
        // Push the value of the checked checkbox into the checkedValues array
        checkedValues.push(checkbox.value);
      }
    });

    // Log the array of checked values
   // console.log("Checked values:", checkedValues); 
    if(checkedValues != ''){   
      $('.background-overlay').hide();
      //$('.background-overlay').css('opacity', 0);
      $('#halo-cart-sidebar').hide();
      $('shopify-payment-terms').hide();
    // Send AJAX request to Shopify to add products to cart
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1, // You can adjust the quantity as needed
        id: checkedValues // Array of product IDs to add to cart
      },
      async:false,
      cache: false, // Disable caching
      dataType: 'json',
      success: function(data) {
       // alert('Products added to cart successfully!');
        // You can optionally redirect to the cart page after successful addition
        setTimeout(function(){  
            window.location.href = '/cart'; 
          
        }, 3000);
      },
      error: function(xhr, textStatus, errorThrown) {
        console.error('Error adding products to cart:', errorThrown);
      }
    });
   // alert(checkedValues);
  }else{
      $('.background-overlay').show();
      $('#halo-cart-sidebar').show();
      $('shopify-payment-terms').show();
   } 
  }

  // Add click event listener to buttons with class "product-form__submit"
  var submitButtons = document.querySelectorAll('#product-add-to-cart');
  submitButtons.forEach(function(button) {
    button.addEventListener('click', handleButtonClick); 
  });
 
 
    // Function to handle label click event
  function checkboxClick(event) {
    // Get the associated checkbox
    var checkbox = event.target.previousElementSibling;

    // Toggle the checked attribute of the associated checkbox
    checkbox.checked = !checkbox.checked;
    
    var checkboxes = document.querySelectorAll('input[name="bundle_add_to_cart[]"]');
    var paymentTermsElement = document.querySelector('shopify-payment-terms');
    var anyChecked = Array.from(checkboxes).some(function(checkbox) {
      return checkbox.checked;
    });
    if (anyChecked) {
      $('shopify-payment-terms').hide();
    } else {
      $('shopify-payment-terms').show();
    }
  }

  // Add click event listener to all labels with class "form-label--checkbox"
  var labels = document.querySelectorAll('.form-label--checkbox');
  labels.forEach(function(label) {
    label.addEventListener('click', checkboxClick);
  });
 
 // On chnage of variant option flor rate
   updateSelectedOptionValues();
  // Attach event listener to flowRateSelect for future changes
var flowRateSelect = document.querySelector('select[name="options[Flow Rate]"]');
flowRateSelect.addEventListener('change', updateSelectedOptionValues);
});

// Define the function to update selected option values
function updateSelectedOptionValues() {
  // On change of variant option flow rate
  var flowRateSelect = document.querySelector('select[name="options[Flow Rate]"]');
  var targetSelects = document.querySelectorAll('.select__target');

  // Get the selected option's value
  var selectedValue = flowRateSelect.value;

  // Find the corresponding select element with class select__target
  targetSelects.forEach(function(select) {
    // Find the option with the same value as selectedValue
    var option = select.querySelector('option[value="' + selectedValue + '"]');
   
    // If the option is found, retrieve its data-variantid attribute
    if (option) {
      var variantId = option.getAttribute('data-varidantid');
      var previousId = option.getAttribute('data-previoustId');
      var variantPrice = option.getAttribute('data-Variant-price');
      
      // Set the option as selected
      option.selected = true;
      
      // Update the input value if an input element exists with the previous ID
      var inputElement = document.getElementById('pr-bundle-'+previousId);  
      if (inputElement) {  
        inputElement.value = variantId; // Set the value to the variantId 
      }
      var priceElement = document.getElementById('price-bundle-'+previousId);  
      if (priceElement) {  
        priceElement.textContent  = '+' + variantPrice; // Set the price  to the variantId 
      }
      
    }
  });
}

